module.exports = __webpack_public_path__ + "assets/4a8bedb95351b11cca499ff1f8cfb743.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/BaseGame_AmbientSpinLoop.mp3
 ** module id = 203
 ** module chunks = 0
 **/